import React from 'react';
import styled from 'styled-components';
import Container from '../components/ui/Container';

const Section = styled.section`
  padding: 6rem 0;
  position: relative;
`;

// Content box with semi-transparent background
const ContentBox = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 2.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #333;
`;

const Content = styled.div`
  font-size: 1.1rem;
  line-height: 1.7;
  color: #555;
  margin-bottom: 2rem;
`;

const ContactForm = styled.form`
  max-width: 600px;
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #444;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 1rem;
  background-color: rgba(255, 255, 255, 0.9);
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #0077cc;
    box-shadow: 0 0 0 3px rgba(0, 119, 204, 0.2);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 1rem;
  background-color: rgba(255, 255, 255, 0.9);
  height: 150px;
  resize: vertical;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #0077cc;
    box-shadow: 0 0 0 3px rgba(0, 119, 204, 0.2);
  }
`;

const Button = styled.button`
  background-color: #0077cc;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #0066b3;
  }
`;

const Contact = () => {
  return (
    <Section>
      <Container>
        <ContentBox>
          <PageTitle>Contact Us</PageTitle>
          <Content>
            <p>
              Whether you're curious about our robots, interested in a partnership, 
              or just want to geek out about the future of expressive robotics – we 
              want to connect with you!
            </p>
          </Content>
          
          <ContactForm>
            <FormGroup>
              <Label htmlFor="name">Name</Label>
              <Input type="text" id="name" placeholder="Your name" />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="email">Email</Label>
              <Input type="email" id="email" placeholder="Your email" />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="message">Message</Label>
              <TextArea id="message" placeholder="Your message"></TextArea>
            </FormGroup>
            
            <Button type="submit">Send Message</Button>
          </ContactForm>
        </ContentBox>
      </Container>
    </Section>
  );
};

export default Contact;